// extracted by mini-css-extract-plugin
export default {"title":"CTAVideoBanner_title__KA+pq","wrapper":"CTAVideoBanner_wrapper__08Pxx"};